import { store, writeStore } from "@/schemas/store";
import { z } from "@/zod";

export const readStoreGroupMember = store
  .extend({
    store_group_id: z.string().length(26),
  })
  .readonly();
export const writeStoreGroupMember = writeStore.extend({
  store_group_id: z.string().length(26),
});
